import React, {useState, useEffect} from 'react';



import {TextCompare} from '../TextCompare/TextCompare'
import {Spinner} from '../Spinner/Spinner'
import {ngramRelatedQuery, ngramFragmentQuery, runNgramQuery} from './queries'
import { textClean } from 'ngram-diff';

import { useNodes } from '../XTextWrapper/NodeContext'


const createExpressionsList = (bindings: any[]): any[] => {
  const expressions: any[] = [];
  bindings.forEach((r) => {
    expressions.push({
      id: r.target.value,
      relationLabel: "Ngram Intersections:" + r.count.value,
      referringResource: "",
      author: r.author?.value,
      authorTitle: r.authorTitle?.value,
      longTitle: r.longTitle?.value,
      show: false,
      isRelatedToRange: "",
      isRelatedTo: r.target.value,
      isRelatedToTranscription: r.targetTranscription?.value,
    })
  })
  return expressions
}




export interface MyComponentProps {
  // Define your prop types here
  info?: any,
  handleChangeBase?: any
  baseText?: string
  surfaceWidth?: number
  resourceid: string // should be a block expression id with or without wordRangeString "@1-3"
  markedExpressions?: any // {this.state.expressionsCumulative}
  handleAddCtRelatedExpressions?: any //{this.props.handleAddCtRelatedExpressions}
  handleShowCollationOverlay?: any //{this.props.handleShowCollationOverlay}
  handleChangeInfo?: any
}


export const NgramDisplay: React.FC<MyComponentProps> = (props) => {
  const resourceid: string = props.resourceid?.split("@")[0]
  const targetRange: string = props.resourceid?.split("@")[1]
  const [relatedExpressions, setRelatedExpressions] = useState<any[] | string>([])
  const [intersectionTotal, setIntersectionTotal] = useState<number>(4)
  
  const { setItemRelatedExpressions } = useNodes();

  useEffect(() => {
    // if targetRange is presents forces query to wait until baseText is present
    if (props.baseText && targetRange){
      // console.log("firing1")
      const tokenizedText = textClean(props.baseText).split(" ");
      const ngramArray = []  
      // console.log("baseText", props.baseText)
      // console.log("tokenizedText", tokenizedText)
      // create a for loop the length of the number of words props.baseText
      // - 3 and + 4 here because we're looking for 4grams
      for (let i = 0; i < (tokenizedText.length - 3); i++){
        const ngramId = `<http://scta.info/resource/ngram/${tokenizedText.slice(i, (i + 4)).join("")}>`
        ngramArray.push(ngramId)
      }
      const ngramRelated = runNgramQuery(ngramFragmentQuery(ngramArray.join(" "), intersectionTotal));
      ngramRelated.then((d: any) => {
        const bindings = d.data.results.bindings;
        const expressions = createExpressionsList(bindings);
        setRelatedExpressions(expressions)
        // Uncomment in order to save all ngram matches into context 
        // TODO: seaprate this from itemRelatedExpressions used by TextCompareWrapper
        setItemRelatedExpressions && setItemRelatedExpressions(expressions)
      })
    }
    // NOTE: prevents general query if a targetRange is present
    // TODO: probably needs to be refactored; useEffect can probably be used better
    else if (!targetRange){
      const ngramRelated = runNgramQuery(ngramRelatedQuery(resourceid, intersectionTotal));
      ngramRelated.then((d) => {
        const bindings = d.data.results.bindings
        const expressions = createExpressionsList(bindings);
        setRelatedExpressions(expressions)
        
        // Uncomment in order to save all ngram matches into context 
        // TODO: seaprate this from itemRelatedExpressions used by TextCompareWrapper
        //setItemRelatedExpressions && setItemRelatedExpressions(expressions)
      })
    }
  }, [resourceid, props.baseText, targetRange, intersectionTotal])
  
  const displayExpressions = () => {
    const displayExpressions = relatedExpressions.map((i: any, index: number) => {
      const marked = props?.markedExpressions?.find((e: any) => e.parentBlock === i.id)
      return (
      
      <div key={index + "-ngram-" + i.id}>
        {marked && <span style={{fontSize: "12px", paddingLeft: "2px", marginLeft: "3px", borderLeft: "3px solid purple"}}>Already Marked via <a href={"/text?resourceid=" + marked.id}>{marked.id}</a></span>}
            {<TextCompare
              info={props.info}
              expressionid={i.id}
              relationLabel={i.relationLabel}
              referringResource={i.referringResource}
              author={i.author}
              authorTitle={i.authorTitle}
              longTitle={i.longTitle}
              isMainText={false}
              handleChangeBase={props.handleChangeBase}
              baseText={props.baseText}
              show={i.show}
              surfaceWidth={props.surfaceWidth}
              isRelatedToRange={i.isRelatedToRange}
              handleAddCtRelatedExpressions={props.handleAddCtRelatedExpressions}
              handleShowCollationOverlay={props.handleShowCollationOverlay}
              handleChangeInfo={props.handleChangeInfo}
            />}
          </div>
          )
    })
    return displayExpressions
  }
  return(
    <div>
      {/* <h4>Ngram Similarity</h4> */}
      <p>
        <span style={{"fontSize": '12px'}}>Ngram Intersection Threshold: {intersectionTotal}
          (<span className='lbp-span-link' title="increase intersection threshold" onClick={() => setIntersectionTotal(intersectionTotal + 1)}> + </span>
          {intersectionTotal > 0 && <> | <span className='lbp-span-link' title="decrease intersection threshold" onClick={() => setIntersectionTotal(intersectionTotal - 1)}> - </span></>})
        </span> 
        </p>
      
      {/* <input type="text" value={scoreMinimumInput} onChange={(e) => setScoreMinimumInput(e.target.value)}></input>
      <button onClick={() => {setScoreMinimumUse(scoreMinimumInput)}}>Re-run Query with new minimum</button> */}
      {relatedExpressions === "retrieving" ? <Spinner/> : displayExpressions()}
    </div>
  )
}
export default NgramDisplay;